import { Box, useTheme } from "@mui/material";
import type { FC } from "react";
import { type Control, Controller } from "react-hook-form";
import { useResource } from "web_myplann/Infrastructure/Translations/Resources";
import { RetirementIconTile } from "web_myplann/Inspiration/Retirement/Components/RetirementIconTile";
import {
	RETIREMENT_LOAN_KIND_COPY,
	RETIREMENT_LOAN_KIND_ICONS,
	RETIREMENT_LOAN_KIND_VALUES,
} from "web_myplann/Inspiration/Retirement/constants";
import type { RetirementLoanFormModel } from "web_myplann/Inspiration/Retirement/Types/RetirementTypes";

type Props = {
	control: Control<RetirementLoanFormModel>;
};

export const RetirementLoanKindFormField: FC<Props> = ({ control }) => {
	const { t } = useResource();
	const theme = useTheme();

	return (
		<Controller
			control={control}
			name="kind"
			render={({ field: { value, onChange } }) => (
				<Box
					display="grid"
					gridTemplateColumns="repeat(2, 1fr)"
					gap={theme.spacingTokens.sm}
				>
					{RETIREMENT_LOAN_KIND_VALUES.map((kind) => (
						<RetirementIconTile
							key={kind}
							icon={RETIREMENT_LOAN_KIND_ICONS[kind]}
							label={t(RETIREMENT_LOAN_KIND_COPY[kind])}
							selected={kind === value}
							onClick={() => onChange(kind)}
						/>
					))}
				</Box>
			)}
		/>
	);
};
